module.exports = __webpack_public_path__ + "static/media/tionphipps.ee542457.png";